import type { SxProps, Theme } from '@mui/material';
import { ADMIN_COLORS } from '../../theme';

export const wizardHeadingSx: SxProps<Theme> = {
  fontSize: '19px',
  fontWeight: 700,
  letterSpacing: '-0.2px',
  color: 'text.primary',
  mb: '16px',
};

export const wizardOutlinedButtonSx: SxProps<Theme> = {
  textTransform: 'none',
  borderRadius: '8px',
  px: 3,
  py: 0.75,
  color: 'text.primary',
  borderColor: ADMIN_COLORS.border,
  backgroundColor: ADMIN_COLORS.surface,
  fontWeight: 500,
  '&:hover': {
    borderColor: ADMIN_COLORS.borderStrong,
    backgroundColor: ADMIN_COLORS.hover,
  },
};

export const wizardContainedButtonSx: SxProps<Theme> = {
  textTransform: 'none',
  borderRadius: '8px',
  px: 4,
  py: 0.75,
  fontWeight: 500,
  backgroundColor: 'theme.main',
  boxShadow: 'none',
  '&:hover': {
    backgroundColor: ADMIN_COLORS.accentHover,
    boxShadow: 'none',
  },
  '&.Mui-disabled': {
    backgroundColor: ADMIN_COLORS.accentDisabled,
    color: '#fff',
  },
};
